import { EActions } from 'redux/actions/EActions';
import { EActionGetType, ECrudType } from 'redux/actions/crud';
import { Recipient } from 'models/notification';

export interface ICrudState {
  error: string;
  isLoading: boolean;
  list: any[];
  dropdown: any[];
  total: number;
  showModal: boolean;
  one?: any;
  obj: any;
  isNew: boolean;
  saved?: any;
  filterOpened?: any;
  recipients: Recipient[];
  notifySuccess?: boolean;
}

export function GetReducer(type: ECrudType, map?: any, mapDropdown?: any, extend?: any) {
  const initalState = {
    error: '',
    isLoading: false,
    list: [],
    dropdown: [],
    showModal: false,
    obj: undefined,
    total: 0,
    isNew: false,
    notifySuccess: false,
    filterOpened: window.innerWidth > 768,
    recipients: [],
  };

  return (state: ICrudState = initalState, action: any) => {
    if (extend) {
      const res = extend(state, action);
      if (res) return res;
    }
    switch (action.type) {
      case type + '_' + EActions.NOTIFY:
        return {
          ...state,
          isLoading: true,
        };
      case type + '_' + EActions.CRUD_LOADING:
        return {
          ...state,
          isLoading: true,
        };
      case type + '_' + EActions.NOTIFY_CLEANUP:
        return {
          ...state,
          isLoading: false,
          notifySuccess: false,
        };
      case type + '_' + EActions.CRUD_TOGGLE_FILTER:
        return {
          ...state,
          filterOpened: !state.filterOpened,
        };
      case type + '_' + EActions.CRUD_CLEANUP:
        if (action.payload)
          return {
            ...state,
            ...action.payload,
          };
        return {
          ...state,
          showModal: false,
          list: [],
          saved: undefined,
          one: undefined,
          recipients: [],
          notifySuccess: false,
        };
      case type + '_' + EActions.CRUD_END_EDIT:
        return { ...state, showModal: false, obj: undefined };
      case type + '_' + EActions.CRUD_BEGIN_EDIT:
        return {
          ...state,
          showModal: true,
          obj: map && action.payload ? map(action.payload) : action.payload,
          isNew: action.payload === undefined,
        };
      case type + '_' + EActions.CRUD_GET:
      case type + '_' + EActions.CRUD_SAVE:
      case type + '_' + EActions.CRUD_DELETE:
        return {
          ...state,
          isLoading: true,
          error: '',
        };
      case type + '_' + EActions.CRUD_REPLACE:
        const obj = action.payload;
        let ddwn: any = (state.dropdown || []).map((d) => (obj.id === d.id ? obj : d));
        let lst: any = (state.list || []).map((d) => (obj.id === d.id ? obj : d));
        if (mapDropdown) ddwn = ddwn.map(mapDropdown);
        if (map) lst = lst.map(map);
        return {
          ...state,
          isLoading: false,
          dropdown: ddwn,
          list: lst,
          one: state.one?.id === obj.id ? obj : state.one,
        };
      case type + '_' + EActions.CRUD_GET_SUCCESS + '_' + EActionGetType.DROPDOWN: {
        let dropdown = action.payload.data;
        if (mapDropdown) dropdown = dropdown.map(mapDropdown);
        return {
          ...state,
          isLoading: false,
          dropdown,
        };
      }
      case type + '_' + EActions.CRUD_GET_SUCCESS + '_' + EActionGetType.LIST:
        let list = action.payload.data;
        if (map) {
          list = list.map(map);
        }
        if (action.append) {
          list = [...state.list, ...list];
        }
        return {
          ...state,
          isLoading: false,
          list,
          total: action.payload.meta.total,
        };
      case type + '_' + EActions.CRUD_GET_FAIL:
        return { ...state, isLoading: false, error: action.payload };

      case type + '_' + EActions.CRUD_SAVE_SUCCESS:
        return { ...state, isLoading: false, saved: action.payload };

      case type + '_' + EActions.NOTIFY_SUCCESS:
        return { ...state, isLoading: false, notifySuccess: true };

      case type + '_' + EActions.GET_ONE_SUCCESS:
        return { ...state, isLoading: false, one: action.payload };

      case type + '_' + EActions.GET_RECIPIENTS_SUCCESS:
        return { ...state, isLoading: false, recipients: action.payload };

      case type + '_' + EActions.CRUD_SAVE_FAIL:
      case type + '_' + EActions.CRUD_DELETE_FAIL:
      case type + '_' + EActions.GET_ONE_FAIL:
      case type + '_' + EActions.GET_RECIPIENTS_FAIL:
      case type + '_' + EActions.NOTIFY_FAIL:
        return { ...state, isLoading: false, error: action.payload };
    }
    return state;
  };
}
